import { Tab } from './tab';

class TabsList {
    constructor() {
        this.kentico = (document.querySelector('body').classList.contains('DesignMode') || document.querySelector('body').classList.contains('EditMode'));
    }
    init(){

        if (!this.kentico){
            this.tabDomElements = document.querySelectorAll('[data-tabs-module], [data-tabsAction-module], [data-tabsoffer-module]')
            this.tabsArr = [];
            [].forEach.call(this.tabDomElements, (el) => {

                let type = "";
                if (el.hasAttribute('data-tabs-module')) type = "basic";
                if (el.hasAttribute('data-tabsAction-module')) type = "action";
                if (el.hasAttribute('data-tabsoffer-module')) type = "offer";

                this.tabsArr.push(new Tab(el, type)); 
            }); 
        }

    }
    refreshTabs(){
        if (!this.kentico){
            [].forEach.call(this.tabsArr, (el) => {
                el.refresh();
            });
        }
    }
}

const tabs = new TabsList();

export { tabs }